import { createUseStyles } from "react-jss";

export default createUseStyles({
    dockedContainer: {
        fontFamily: "Open Sans",
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        width: 384,
        top: 0,
        boxShadow: "3px 0px 28px #00000029",
        left: ({ position }) => (position === "left" ? 0 : "auto"),
        right: ({ position }) => (position === "right" ? 0 : "auto"),
        height: "100%",
        background: "white",
        zIndex: 10,
        padding: 50,
        paddingRight: 30,
        boxSizing: "border-box",
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    titleContainer: {
        flex: "1",
        marginTop: -8,
    },
    title: {
        fontSize: "19px",
        fontWeight: 700,
        margin: 0,
        padding: 0,
    },
    subtitle: {
        fontSize: "15px",
        fontWeight: 500,
        margin: 0,
        padding: 0,
    },
    debugIcon: {
        fontSize: "50px",
        marginRight: 12,
        marginLeft: -8,
    },
    panel: {
        flex: 1,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    panelButtonContainer: {
        display: "flex",
        flexDirection: "row",
        margin: [[17, -8]],
    },
    panelButton: {
        margin: 8,
        width: 40,
        height: 40,
        lineHeight: "40px",
        textAlign: "center",
        borderRadius: "50%",
        background: "#DFDFDF",
        color: "#616161",
        cursor: "pointer",
        transition: "background 200ms, color 200ms",

        "&:hover": {
            background: "#ccc",
        },
    },
    panelButtonSmall: {
        margin: 8,
        width: 30,
        height: 30,
        lineHeight: "30px",
    },
    panelButtonIcon: {
        fontSize: "18px",
    },
    panelButtonActive: {
        background: "#FFA200",
        color: "#fff",
        position: "relative",

        "&:hover": {
            background: "#FFA200",
        },
    },
    toolbar: {
        marginTop: 25,
        display: "flex",
        alignItems: "center",
    },
});
